<script setup>
import { ref, reactive, computed, onBeforeMount, onMounted, defineComponent } from 'vue'
import { showToast } from 'vant';
import copy from 'copy-to-clipboard'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import "swiper/css/navigation";
import { Navigation, Mousewheel } from 'swiper/modules';
import modules1View from './PCViews/modules1View.vue';
import modules2View from './PCViews/modules2View.vue';
import modules3View from './PCViews/modules3View.vue';
import modules4View from './PCViews/modules4View.vue';
import { userInfoStore, rewardListStore } from '@/stores/counter.js'
import { getReqData, loginAPI,  } from '@/util/api'
import mystical from "@/util/mystical"

const modules = ref([Navigation, Mousewheel])
const ElementSwiper = defineComponent(Swiper)
const ElementSwiperSlide = defineComponent(SwiperSlide)
const swiperInstance = ref();
const swiperIndex = ref(0)
const childRef = ref()
const childRef1 = ref()
const childRef3 = ref()
const childRef4 = ref()
const showLoginPop = ref(false)
const showAppoSucPop = ref(false)
const userStore = userInfoStore()
const rewardStore = rewardListStore()
const userInfo = computed(() => {
  return userStore.userInfo
})
const sendData = ref({
  email: '',
  scode: '',
  os: 2
})
const claimText = ref('')
let codeData = ref([])
const agree = ref(false)
let isWait = ref(false)
const timeOut1 =  ref(null)
const count1 = ref(60)
let loginObj = ref({
  uname: '',
  upwd: ''
})

const onSwiper = (swp) => {
  swiperInstance.value = swp
}
const switchSlide = (index) => {
  swiperInstance.value.slideTo(index, 500, false);
  swiperIndex.value = index
}
const onSlideChange = (index) => {
  console.log('【onSlideChange】', index.activeIndex)
  swiperIndex.value = index.activeIndex
  if (swiperIndex.value == 0) {
    childRef1.value.audioPlay()
  } else {
    childRef1.value.stopAudio()
  }
  if (swiperIndex.value == 1) {
    childRef.value.audioPlay()
  }
  if ((swiperIndex.value == 2 || swiperIndex.value == 3) && !userInfo.value) {
    console.log('【前往充值界面没登陆】', userInfo.value);
    showLoginPop.value = true
  }
}

const needLogin = () => {
  showLoginPop.value = true
}
const configLogin = () => {
  if (!loginObj.value.uname) {
    showToast({ type: 'fail', message: '아이디를 입력해주세요.', className:'toast-fail' })
    return
  }
  if (!loginObj.value.upwd) {
    showToast({ type: 'fail', message: '비밀번호를 입력해주세요.', className:'toast-fail' })
    return
  }
  loginAPI(getReqData(loginObj.value)).then(res => {
    if (res.data.code == 0) {
      showToast({ type: 'success', message: res.data.msg, className:'toast-success' })
      userStore.setUserInfo(res.data.data)
      localStorage.setItem(
        "2G19fZeORY8=",
        mystical.des_encrypt(JSON.stringify(res.data.data))
      );
      localStorage.setItem(
        "FiJISxKHfpo=",
        mystical.des_encrypt(res.data.data.token)
      );
      childRef1.value.getCommunication()
      childRef3.value.getUserRole()
      childRef4.value.getCommunication()
      console.log('【测试】');
      
      showLoginPop.value = false
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}

const closeLoginPop = () => {
  showLoginPop.value = false
  if ((swiperIndex.value == 2 || swiperIndex.value == 3) && !userInfo.value) {
    swiperInstance.value.slideTo(0, 500, false);
  }
}
const goCustomer = () => {
  if (localStorage.getItem('config-record')) {
    window.location.href = JSON.parse(localStorage.getItem('config-record')).download[2].value
  }
}
const closeAppoSucPop = () => {
  showAppoSucPop.value = false
}
const updateCommunication = () => {
  childRef1.value.getCommunication()
}


const delayedCode = () => {
  if (count1.value > 0) {
    timeOut1.value = setTimeout(() => {
      count1.value--
      delayedCode()
    }, 1000)
  } else {
    clearTimeout(timeOut1.value)
    isWait.value = false
    count1.value = 60
  }
}

const joinFb = () => {
  console.log('[open]');
  childRef3.value.updateTaskStatus(3)
}
const joinDs = () => {
  childRef3.value.updateTaskStatus(4)
}

const doCopy = (text) => {
  copy(text)
  showToast({ type: 'success', message: 'Link copied successfully, go ahead and share it!', className:'toast-success' })
}

onBeforeMount(() => {
  console.log('【渲染后】');
  if (localStorage.getItem("2G19fZeORY8=")) {
    userStore.setUserInfo(JSON.parse(mystical.des_decrypt(localStorage.getItem("2G19fZeORY8="))))
  }
})
onMounted(() => {
  console.log('【渲染前】');
  
})
</script>

<template>
  <section class="home-box">
    <ElementSwiper
      @swiper="onSwiper"
      @slideChange="onSlideChange"
      :slides-per-view="1"
      :modules="modules"
      :space-between="0"
      :mousewheel="true"
      :direction="'vertical'"
      style="width: 100%; height: 100%;"
    >
      <ElementSwiperSlide>
        <modules1View ref="childRef1" @needLogin="needLogin" @goNextPage="switchSlide(1)" @goPayPage="switchSlide(2)" @goBinding="switchSlide(3)" />
      </ElementSwiperSlide>
      <ElementSwiperSlide>
        <modules2View ref="childRef" @needLogin="needLogin" @goPayPage="switchSlide(2)" />
      </ElementSwiperSlide>
      <ElementSwiperSlide>
        <modules3View ref="childRef3" @needLogin="needLogin" />
      </ElementSwiperSlide>
      <ElementSwiperSlide>
        <modules4View ref="childRef4" @updateCommunication="updateCommunication"/>
      </ElementSwiperSlide>
    </ElementSwiper>
    <section class="nav-box">
      <img src="../assets/img/nav/logo.png" alt="" style="position: absolute; left: 0.48rem; width: 2.16rem;">
      <section class="menupc-box">
        <aside :class="swiperIndex == 0 ? 'menu-item menu-item-active' : 'menu-item'" @click="switchSlide(0)">
          <img src="@/assets/img/nav/navp01.png" alt="" style="height: 0.28rem;">
        </aside>
        <aside :class="swiperIndex == 1 ? 'menu-item menu-item-active' : 'menu-item'" @click="switchSlide(1)">
          <img src="@/assets/img/nav/navp02.png" alt="" style="height: 0.28rem;">
        </aside>
        <aside :class="swiperIndex == 2 ? 'menu-item menu-item-active' : 'menu-item'" @click="switchSlide(2)">
          <img src="@/assets/img/nav/navp03.png" alt="" style="height: 0.28rem;">
        </aside>
        <aside :class="swiperIndex == 3 ? 'menu-item menu-item-active' : 'menu-item'" @click="switchSlide(3)">
          <img src="@/assets/img/nav/navp04.png" alt="" style="height: 0.28rem;">
        </aside>
      </section>
    </section>
    <section class="mask-box" v-show="showLoginPop">
      <section class="login-box">
        <aside style="display: flex; justify-content: space-between; align-items: center; height: 36px; width: 100%;">
          <span style="font-size: 16px; color: #ffffff; margin-left: 12px;">게임 계정 로그인</span>
          <img src="@/assets/img/nav/close-icon.png" alt="" @click="closeLoginPop" style="height: 28px; margin-right: 12px;">
        </aside>
        <aside class="input-box" style="margin-top: 36px;">
          <img class="icon" src="@/assets/img/nav/nm-icon.png" alt="">
          <input type="text" v-model="loginObj.uname" placeholder="아이디를 입력해주세요">
        </aside>
        <aside class="input-box" style="margin-top: 20px;">
          <img class="icon" src="@/assets/img/nav/mm-icon.png" alt="">
          <input type="password" name="" id="" v-model="loginObj.upwd" placeholder="비밀번호를 입력해주세요">
        </aside>
        <img src="@/assets/img/nav/login-btn.png" alt="" @click="configLogin" style="height: 44px; margin-top: 42px;">
        <aside style="display: flex; justify-content: space-between; margin-top: 36px; width: 380px;">
          <button @click="switchSlide(0)" style="font-size: 16px; font-weight: bold; color: rgb(90, 131, 208); border: none; background: none;">건너뛰기</button>
          <button @click="goCustomer" style="font-size: 16px; font-weight: bold; color: rgb(90, 131, 208); border: none; background: none;">비밀번호 찾기</button>
        </aside>
      </section>
    </section>
    <!--  -->
    <!-- <section class="mask-box" v-show="showAppoSucPop">
      <section class="mask-content">
        <span class="text-sys3 font-type3" style="width: 80%; margin: 28px 0px 12px; text-align: center; font-size: 15px;">Thank you for joining, hero!</span>
        <span class="text-sys3 font-type3" style="width: 88%; text-align: center; font-size: 15px; line-height: 1.5;">The fate of the world changes with every choice.</span>
        <span class="text-sys3 font-type3" style="width: 88%; text-align: center; font-size: 15px; line-height: 1.5;">Your reward will be available when the world opens.</span>
        <img src="@/assets/img/pop/xuan.png" alt="" style="width: 78%; margin: 18px 0px;">
        <span class="text-sys3 font-type3" style="width: 80%; text-align: center; font-size: 15px;">The adventure begins now...</span>
        <span class="text-sys3 font-type3" style="width: 80%; text-align: center; font-size: 15px; margin-top: 12px; line-height: 1.5;">Join the Vanguard's Alliance for exclusive<br />intel and battle reports:</span>
        <aside style="display: flex; justify-content: space-between; align-items: center; width: 82%; margin: 24px 0px;">
          <img src="@/assets/img/pop/Facebook.png" alt="" @click="joinFb" style="height: 54px; margin-left: 36px;">
          <img src="@/assets/img/pop/Discord.png" alt="" @click="joinDs" style="height: 54px; margin-right: 36px;">
        </aside>
      </section>
      <img src="@/assets/img/pop/close.png" alt="" @click="closeAppoSucPop" style="width: 38px; margin-top: 20px;">
    </section> -->
    <!--  -->
    <!--  -->
  </section>
</template>

<style scoped>
.home-box {
  width: 100%;
  min-width: 13.8rem;
  height: 100vh;
  position: relative;
}
.nav-box {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 9;
  background: url('../assets/img/nav/meupc-bac.png') no-repeat;
  background-size: 100% 100%;
  height: 0.96rem;
}
.menupc-box {
  flex: 1;
  display: flex;
  justify-content: center;
}
.menu-item {
  position: relative;
  /* height: 0.34rem; */
  margin: 0px 0.48rem;
  display: flex;
  align-items: center;
  padding: 0rem 0.08rem;
}
.menu-item-active {
  background: rgb(255 255 255 / 20%);
}

.name-box {
  z-index: 4;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.name-box-a {
  z-index: 4;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: url('../assets/img/nav/name-bac.png') no-repeat;
  background-size: 100% 100%;
  padding: 0.05rem 0.15rem;
}
.name-box img, .name-box-a img {
  display: block;
}

.mask-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(0 0 0 / 80%);
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.mask-content {
  background: url('../assets/img/pop/pop-bj-pc.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 0px;
  width: 648px;
}
.text-sys2 {
  font-size: 14px;
  font-weight: bolder;
  color: #9d4f23;
  /* text-shadow: -0.2px -0.2px 0 #fff1d6, 0.2px -0.2px 0 #fff1d6, -0.2px 0.2px 0 #fff1d6, 0.2px 0.2px 0 #fff1d6; */
}
.text-sys3 {
  font-size: 14px;
  /* font-weight: bolder; */
  color: #443421;
  /* text-shadow: -0.2px -0.2px 0 #fff1d6, 0.2px -0.2px 0 #fff1d6, -0.2px 0.2px 0 #fff1d6, 0.2px 0.2px 0 #fff1d6; */
}
.in-kuang {
  height: 24px;
  background: rgb(172, 154, 128);
  padding: 6px 12px;
  box-shadow: 0px 0px 4px 0px #efefef;
  border: none;
  border-radius: 5px;
  flex: 1;
}
.lq-btn {
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #999999;
  border-radius: 6px;
  padding: 0px 12px;
  margin-left: 6px;
  font-size: 13px;
  color: #443421;
}
.gk-box {
  width: 18px;
  height: 18px;
  border: 2px solid #443421;
  margin-right: 6px;
  position: relative;
}

.login-box {
  width: 480px;
  height: 360px;
  background: url('../assets/img/nav/login-bac.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.input-box {
  width: 384px;
  height: 42px;
  display: flex;
  position: relative;
}
.input-box input {
  display: block;
  width: 308px;
  padding: 0px 6px 0px 54px;
  font-size: 15px;
  border: 1px solid rgb(196, 132, 94);
  border-radius: 12px;
}
input::placeholder {
  color: #cdcdcd;
}
.input-box .icon {
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
}
</style>
